import { render, staticRenderFns } from "./person.block.pug?vue&type=template&id=386546da&scoped=true&lang=pug&external"
import script from "./person.block.ts?vue&type=script&lang=ts&external"
export * from "./person.block.ts?vue&type=script&lang=ts&external"
import style0 from "./person.block.sass?vue&type=style&index=0&id=386546da&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386546da",
  null
  
)

export default component.exports